import { jsxs as _jsxs } from "react/jsx-runtime";
import { StyledButtonMarcar } from './style';
export default function MarcarDesmarcarButton({ selectedItems, allOptions, onChange, avoidPropagation, style, }) {
    const showUnselect = selectedItems.length > 0;
    const handleToggle = (e) => {
        avoidPropagation === null || avoidPropagation === void 0 ? void 0 : avoidPropagation(e);
        if (showUnselect) {
            onChange([]);
        }
        else {
            onChange(allOptions);
        }
    };
    return (_jsxs(StyledButtonMarcar, Object.assign({ style: style, onClick: handleToggle }, { children: [showUnselect ? 'Desmarcar' : 'Marcar', " Todos"] })));
}
